var slider_img = document.querySelectorAll('.banner-wrapper div');
var duration = 10;

export const banner_slider = (slider_el) => {
    for (var i = 0; i < slider_el.length; i++) {
        slider_el[i].style.animationDelay = `${i*duration}s`;
        slider_el[i].style.animationDuration = `${duration*slider_el.length}s`;
    };
};

banner_slider(slider_img)